import React from 'react';
import styles from './vastu.module.css';
import { FaHome, FaBuilding, FaBalanceScale, FaChartLine, FaHeart, FaShieldAlt, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
// import Header from '../../Header';

const VastuConsultation = () => {
  return (
    <>
    
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1>Vastu Consultation for Your Property</h1>
          <p className={styles.subtitle}>Balance Energy, Boost Prosperity</p>
          <p className={styles.heroText}>
            Harmonize Your Space. Attract Wealth, Health & Happiness. Looking to align your home, office, or real estate investment with the principles of Vastu Shastra?
          </p>
          <p>
            At Property Plateau Realty, we offer expert Vastu consultation services that blend ancient science with modern living to unlock positive energy flow, financial success, and emotional well-being.
          </p>
          <div className={styles.ctaButtons}>
            <button className={`${styles.button} ${styles.primary}`}>Schedule Free Call</button>
            <button className={`${styles.button} ${styles.secondary}`}>Request Site Visit</button>
          </div>
        </div>
        <div className={styles.heroImage}>
          <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="Harmonious home with Vastu principles" />
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Why Choose Vastu Consultation from Property Plateau?</h2>
        <div className={styles.featuresGrid}>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <FaHome />
            </div>
            <h3>Certified Vastu Experts</h3>
            <p>Our consultants are experienced, certified professionals with a deep understanding of traditional Vastu, geography, energy mapping, and space design.</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <FaBuilding />
            </div>
            <h3>On-Site & Virtual Consultations</h3>
            <p>Whether you're building, buying, or renovating, we offer flexible consultation modes—virtual for quick advice and on-site for in-depth analysis.</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <FaBalanceScale />
            </div>
            <h3>Remedy Without Demolition</h3>
            <p>We recommend non-invasive Vastu remedies using energy balancing, color therapy, symbols, and placements—no need to break walls or alter your layout.</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <FaChartLine />
            </div>
            <h3>Buy or Sell Vastu-Compliant Properties</h3>
            <p>Get help identifying Vastu-perfect homes or rectifying imbalances before sale to boost market value and buyer confidence.</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
            <FaShieldAlt />
          </div>
          <h3>Residential & Commercial Properties</h3>
          <p>From flats and villas to retail stores and office spaces, our guidance helps maximize cosmic alignment and ensure abundance & peace.</p>
         </div>
        </div>
        

      </section>

      {/* Consultation Coverage Section */}
      <section className={`${styles.section} ${styles.darkBg}`}>
        <h2 className={styles.sectionTitle}>What We Cover in a Vastu Consultation</h2>
        <div className={styles.coverageGrid}>
          <div className={styles.coverageItem}>
            <img src="https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Plot analysis" />
            <div className={styles.coverageContent}>
              <h3>Plot and Entrance Analysis</h3>
              <p>Evaluate the plot's orientation, shape, and entrance placement for optimal energy flow.</p>
            </div>
          </div>
          <div className={styles.coverageItem}>
            <img src="https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Room placement" />
            <div className={styles.coverageContent}>
              <h3>Room Placement Guidance</h3>
              <p>Optimal positioning for bedrooms, kitchen, toilets, and other important spaces.</p>
            </div>
          </div>
          <div className={styles.coverageItem}>
            <img src="https://images.unsplash.com/photo-1518481852452-9415b262eba4?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Element balancing" />
            <div className={styles.coverageContent}>
              <h3>Element Balancing</h3>
              <p>Harmonize Earth, Water, Fire, Air, and Space elements in your property.</p>
            </div>
          </div>
          <div className={styles.coverageItem}>
            <img src="https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Energy zones" />
            <div className={styles.coverageContent}>
              <h3>Energy Zone Mapping</h3>
              <p>Identify and enhance Money, Health, Career, and Relationship zones.</p>
            </div>
          </div>
          <div className={styles.coverageItem}>
            <img src="https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Color therapy" />
            <div className={styles.coverageContent}>
              <h3>Interior Color & Object Placement</h3>
              <p>Recommendations for colors, furniture placement, and decorative elements.</p>
            </div>
          </div>
          <div className={styles.coverageItem}>
            <img src="https://images.unsplash.com/photo-1513519245088-0e12902e5a38?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Vastu remedies" />
            <div className={styles.coverageContent}>
              <h3>Custom Remedies & Corrections</h3>
              <p>Personalized solutions for your specific Vastu challenges.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Benefits of Vastu-Compliant Spaces</h2>
        <div className={styles.benefitsGrid}>
          <div className={styles.benefitCard}>
            <FaChartLine className={styles.benefitIcon} />
            <h3>Increased Wealth & Prosperity</h3>
            <p>Optimize money flow and attract abundance through proper energy alignment.</p>
          </div>
          <div className={styles.benefitCard}>
            <FaHeart className={styles.benefitIcon} />
            <h3>Improved Health & Family Harmony</h3>
            <p>Create spaces that promote physical well-being and positive relationships.</p>
          </div>
          <div className={styles.benefitCard}>
            <FaBuilding className={styles.benefitIcon} />
            <h3>Enhanced Focus & Career Growth</h3>
            <p>Office spaces designed for productivity and professional success.</p>
          </div>
          <div className={styles.benefitCard}>
            <FaShieldAlt className={styles.benefitIcon} />
            <h3>Protection from Negative Energies</h3>
            <p>Shield your space from harmful influences and create positive vibrations.</p>
          </div>
          <div className={styles.benefitCard}>
            <FaHome className={styles.benefitIcon} />
            <h3>Higher Resale Value</h3>
            <p>Vastu-compliant properties command better market prices and buyer interest.</p>
          </div>
          <div className={styles.benefitCard}>
            <FaBalanceScale className={styles.benefitIcon} />
            <h3>Emotional Well-being</h3>
            <p>Spaces that promote peace, happiness, and mental clarity.</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className={`${styles.section} ${styles.testimonialSection}`}>
        <h2 className={styles.sectionTitle}>Client Testimonials</h2>
        <div className={styles.testimonials}>
          <div className={styles.testimonialCard}>
            <div className={styles.testimonialContent}>
              <p>"We followed Property Plateau's Vastu suggestions during our home renovation, and within months, saw a dramatic improvement in our finances."</p>
              <div className={styles.testimonialAuthor}>
                <strong>Meenal S.</strong>
                <span>Pune</span>
              </div>
            </div>
          </div>
          <div className={styles.testimonialCard}>
            <div className={styles.testimonialContent}>
              <p>"Their remedies were easy to apply and didn't require structural changes. My office now feels more vibrant and productive."</p>
              <div className={styles.testimonialAuthor}>
                <strong>Kunal M.</strong>
                <span>Mumbai</span>
              </div>
            </div>
          </div>
          <div className={styles.testimonialCard}>
            <div className={styles.testimonialContent}>
              <p>"The Vastu report helped us identify key issues in our new apartment. After implementing the suggestions, we've noticed better sleep and family harmony."</p>
              <div className={styles.testimonialAuthor}>
                <strong>Priya R.</strong>
                <span>Bangalore</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Locations We Serve</h2>
        <div className={styles.locationsGrid}>
          <div className={styles.locationCard}>
            <FaMapMarkerAlt className={styles.locationIcon} />
            <h3>Mumbai</h3>
          </div>
          <div className={styles.locationCard}>
            <FaMapMarkerAlt className={styles.locationIcon} />
            <h3>Pune</h3>
          </div>
          <div className={styles.locationCard}>
            <FaMapMarkerAlt className={styles.locationIcon} />
            <h3>Goa</h3>
          </div>
          <div className={styles.locationCard}>
            <FaMapMarkerAlt className={styles.locationIcon} />
            <h3>Bangalore</h3>
          </div>
          <div className={styles.locationCard}>
            <FaMapMarkerAlt className={styles.locationIcon} />
            <h3>Hyderabad</h3>
          </div>
          <div className={styles.locationCard}>
            <FaMapMarkerAlt className={styles.locationIcon} />
            <h3>Delhi-NCR</h3>
          </div>
        </div>
        <p className={styles.locationNote}>Pan-India and Global Virtual Consultations Available</p>
      </section>

      {/* Final CTA Section */}
      <section className={`${styles.section} ${styles.ctaSection}`}>
        <div className={styles.ctaContent}>
          <h2 className={styles.ctaTitle}>Book Your Personalized Vastu Consultation Today</h2>
          <p className={styles.ctaText}>Bring your property into alignment with universal energy and ancient wisdom.</p>
          <div className={styles.ctaButtons}>
            <button className={`${styles.button} ${styles.primary}`}>
              <FaPhone /> Schedule Free Call
            </button>
            <button className={`${styles.button} ${styles.secondary}`}>
              <FaEnvelope /> Request Vastu Report
            </button>
          </div>
        </div>
        <div className={styles.ctaImage}>
          <img src="https://images.unsplash.com/photo-1600121848594-d8644e57abab?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Vastu consultation" />
        </div>
      </section>
    </div>
    </>
  );
};

export default VastuConsultation;